import apiConfig from '../config/apiConfig';
import { apiFetch } from './apiClient';

export async function pingService() {
  const path = apiConfig.PING_PATH || '/ping';
  return apiFetch(path, { method: 'GET' });
}

export async function applyTelephonyProfile(payload) {
  return apiFetch('/api/telephony/profile/apply', {
    method: 'POST',
    body: payload
  });
}
